"use client";

import { useMemo } from "react";

export type LogoMarqueeItem =
  | { src: string; alt: string; width: number; label?: never }
  | { label: string; width: number; src?: never; alt?: never };

interface LogoMarqueeProps {
  logos: LogoMarqueeItem[];
  className?: string;
}

export function LogoMarquee({ logos, className = "" }: LogoMarqueeProps) {
  // Exact width of one full set including gaps: sum(widths) + N * 64px gap
  const setWidth = useMemo(
    () => logos.reduce((s, l) => s + l.width, 0) + logos.length * 64,
    [logos]
  );

  return (
    <div className={`overflow-x-clip w-full opacity-80 ${className}`}>
      <div
        className="flex animate-[marquee_45s_linear_infinite] will-change-transform"
        style={{ gap: 64 }}
      >
        {[...logos, ...logos, ...logos].map((logo, i) => (
          <div
            key={i}
            className="h-[42px] shrink-0 flex items-center justify-center overflow-hidden"
            style={{ width: `${logo.width}px` }}
          >
            {"src" in logo ? (
              <img
                src={logo.src}
                alt={logo.alt}
                className="max-h-full max-w-full object-contain"
              />
            ) : (
              <span
                className="inline-flex h-[42px] items-center justify-center px-[10px] text-[20px] font-semibold leading-[24px] text-black/55 grayscale"
                style={{ fontFamily: "var(--font-commissioner)", fontVariationSettings: '"FLAR" 0, "VOLM" 0' }}
              >
                {logo.label}
              </span>
            )}
          </div>
        ))}
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-${setWidth}px); }
        }
      `}</style>
    </div>
  );
}
